// extracted by mini-css-extract-plugin
module.exports = {"tierModal":"DiscountTiersModal_tierModal__S5Wd-"};